import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { ResumeDatabaseBanner } from 'components/Banners/ResumeDatabaseBanner';
import { SalarySurveyBanner } from 'components/Banners/SalarySurveyBanner';
import { Box } from 'components/Box';
import { ClientOnly } from 'containers/ClientOnly';
import { State as MainState } from 'store/main';
import { setHadSalarySurveyAd } from 'store/main/ducks/layout';
import { promoteResumeDatabase } from 'utils/resumeDatabase';
import { promoteSalarySurvey } from 'utils/salarySurvey';

export function BannerAds() {
  const { currentUser, hadSalarySurveyAd, hideSalarySurveyAd } = useSelector(
    (state: MainState) => ({
      // @ts-expect-error fix me
      hadSalarySurveyAd: state.layout.hadSalarySurveyAd,
      // @ts-expect-error fix me
      hideSalarySurveyAd: state.layout.hideSalarySurveyAd,
      currentUser: state.currentUser,
    })
  );
  const dispatch = useDispatch();
  const history = useHistory();

  const hasSalarySurveyBanner =
    !history.location.pathname.includes('/survey') &&
    !hideSalarySurveyAd &&
    promoteSalarySurvey({
      // @ts-expect-error fix me
      currentUser,
      allowDismissal: true,
    });

  useEffect(() => {
    if (currentUser.isLoaded && !hadSalarySurveyAd && hasSalarySurveyBanner) {
      dispatch(setHadSalarySurveyAd(true));
    }
  }, [
    currentUser.isLoaded,
    dispatch,
    hadSalarySurveyAd,
    hasSalarySurveyBanner,
  ]);

  const hasResumeDatabaseBanner =
    !hasSalarySurveyBanner &&
    !hadSalarySurveyAd &&
    promoteResumeDatabase({
      // @ts-expect-error fix me
      currentUser,
      allowLoggedOut: true,
    });

  return (
    <Box
      data-qa-id="ads-container"
      mt={[60, null, null, 0]}
      mb={[-60, null, null, 0]}
    >
      <ClientOnly>
        {hasResumeDatabaseBanner && (
          // @ts-expect-error fix me
          <ResumeDatabaseBanner currentUser={currentUser} />
        )}
        {hasSalarySurveyBanner && <SalarySurveyBanner />}
      </ClientOnly>
    </Box>
  );
}
